import React from "react";
import DashboardContent from "./components/DashboardContent";
import HomeSkeleton from "./components/HomeSkeleton";
import useClientQuery from "../../global/queries/useClientQuery";

export default function Dashboard() {

    const { isLoading, isError} = useClientQuery();

    if (isLoading) return <HomeSkeleton/>;

    if (isError) return <p>Error occurred while fetching client data</p>;

    return <DashboardContent/>

}
